import { faTimes, faPlus, faEdit, faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Component, inject, OnInit } from '@angular/core';
import { TasksService } from 'src/app/services/tasks.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-builder-index',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Tareas y técnicos</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tasks [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Constructor</h2>
          </div>
        </div>
        <div class="d-flex">
          <div>
          <button class="btn btn-zazz-dark" *ngIf="authService.hasPermission('can_create_builder')" routerLink="create">
              <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
              Agregar constructor
            </button>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let builder of builders | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: 10 }"
                >
                  <td>{{builder.name}}</td>
                  <td>{{builder.updated_at | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>
                    <button class="btn btn-outline-primary text-end" routerLink="{{builder.id}}" *ngIf="authService.hasPermission('can_edit_builder')">
                      <fa-icon [icon]="faEdit" size="1x"></fa-icon>
                      Editar
                    </button>
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="builders.length === 0 && loading">
            <fa-icon [icon]="faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="builders.length === 0 && !loading">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron registros</h5>
          </div>
          <div class="list-group-item text-center pt-3">
            <pagination-controls
              (pageChange)="p = $event"
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"                  
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class BuilderIndexComponent implements OnInit {
  loading: boolean = false;
  builders: any[] = [];
  meta: any = {};
  searchBox: FormGroup = new FormGroup({});
  profile: any = {};
  permissions: any = {};

  faTimes = faTimes;
  faPlus = faPlus;
  faEdit = faEdit;
  faCircleNotch = faCircleNotch;

  currentView: string = 'builders';

  payload: any = {
    page: 1,
    per_page: 10,
  };

  p: number = 1;
  storageService = inject(StorageService);
  constructor(
    private tasks: TasksService,
    private fb: FormBuilder,
    private breadcrumbService: BreadcrumbService,
    private toastr: ToastrService,
    public authService: AuthService
  ) {
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) ? this.storageService.getItem(STORAGE_KEYS.PERMISSIONS) : null;
    this.payload.profile_id = this.profile.id;
  }

  ngOnInit(): void {
    this.breadcrumbService.set('@builder', 'Constructor de tareas');
    this.loadBuilders();
    this.initForm();
  }

  initForm() {
    this.searchBox = this.fb.group({
      search: [''],
    });
  }

  loadBuilders() {
    this.loading = true;
    this.tasks.getBuilders(this.payload).subscribe({
      next: (builders: any) => {
        this.builders = builders.data ?? [];
        this.meta = builders.meta;
        this.loading = false;
      },
      error: (err: any) => {
        this.builders = [];
        this.loading = false;
      },
    });
  }

  searchBuilder(event: any) {
    this.payload.name = this.searchBox.value.search;
    this.loadBuilders();
  }

  pageChanged(event: any) {
    this.payload.page = event;
    this.loadBuilders();
  }

}
